export const ContainerRelatorio = (props: {arquivoUrl: string}) => {
    return (
        <div style={{height: '70vh', marginTop: '1em'}}>
            <iframe width={"100%"} height={"100%"} src={props.arquivoUrl}></iframe>
        </div>
    )
}